import React, { useState, useContext, useEffect } from 'react';
import { FaAngleDown, FaBell } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import Clock from './Clock';
import api from '../api/axiosConfig';
import './Header.css';

const Header = ({ setSidebarOpen }) => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [notifDropdownOpen, setNotifDropdownOpen] = useState(false);
  
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const handleLogout = () => {
    logout();
    setProfileDropdownOpen(false);
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      if (!user) return;
      try {
        const { data } = await api.get('/api/notifikasi');
        setNotifications(data);
        setUnreadCount(data.filter(n => !n.isRead).length);
      } catch (error) {
        console.error("Gagal mengambil notifikasi:", error);
      }
    };

    fetchNotifications();
    const intervalId = setInterval(fetchNotifications, 60000);

    return () => clearInterval(intervalId);
  }, [user]);

  const handleNotificationClick = async (notification) => {
    navigate(notification.link);
    setNotifDropdownOpen(false);
    if (!notification.isRead) {
      try {
        await api.patch(`/api/notifikasi/${notification._id}/read`);
        setNotifications(notifications.map(n => n._id === notification._id ? { ...n, isRead: true } : n));
        setUnreadCount(prev => prev - 1);
      } catch (error) {
        console.error("Gagal menandai notifikasi:", error);
      }
    }
  };

  const handleMarkAllRead = async () => {
    try {
        await api.post('/api/notifikasi/read-all');
        setNotifications(notifications.map(n => ({ ...n, isRead: true })));
        setUnreadCount(0);
    } catch (error) {
        console.error("Gagal menandai semua notifikasi:", error);
    }
  };

  const getAvatarUrl = () => {
    if (user?.avatar) {
      return `${process.env.REACT_APP_API_URL}/uploads/${user.avatar}`;
    } else {
      return `https://i.pravatar.cc/32?u=${user?.email || 'default'}`;
    }
  };

  return (
    <header className="header">
      {/* <button className="hamburger-btn" onClick={() => setSidebarOpen(true)}> */}
        <div className="header-right" style={{ marginLeft: 'auto' }}>
          <Clock />

          {(user.role === 'superadmin' || user.role === 'operator') && (
            <div className="notification-wrapper">
              <button className="notification-btn" onClick={() => setNotifDropdownOpen(!notifDropdownOpen)}>
                <FaBell />
              </button>
              {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
              
              {notifDropdownOpen && (
                <div className="notification-dropdown">
                  <div className="notification-dropdown-header">
                    <h4>Notifikasi</h4>
                    {unreadCount > 0 && <button onClick={handleMarkAllRead}>Tandai semua dibaca</button>}
                  </div>
                  <ul className="notification-list">
                    {notifications.length > 0 ? (
                      notifications.map(notif => (
                        <li key={notif._id} className={`notification-item ${!notif.isRead ? 'notification-item--unread' : ''}`} onClick={() => handleNotificationClick(notif)}>
                          <p>{notif.message}</p>
                          <span>{new Date(notif.createdAt).toLocaleString('id-ID')}</span>
                        </li>
                      ))
                    ) : (
                      <li className="no-notifications">Tidak ada notifikasi</li>
                    )}
                  </ul>
                </div>
              )}
            </div>
          )}

          <div className="profile-dropdown" onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}>
            <div className="profile-info">
              <img src={getAvatarUrl()} alt="User Avatar" />
              <span>{user ? user.name : 'User'} ({user ? user.role : '-'})</span>
              <FaAngleDown />
            </div>
            {profileDropdownOpen && (
              <ul className="dropdown-menu">
                <li><Link to="/edit-profile" onClick={() => setProfileDropdownOpen(false)}>Edit Profil</Link></li>
                {user && user.role === 'superadmin' && (
                  <li><Link to="/manage-users" onClick={() => setProfileDropdownOpen(false)}>Manage Users</Link></li>
                )}
                <li onClick={handleLogout}>Logout</li>
              </ul>
            )}
          </div>
        </div>
      {/* </button> */}
    </header>
  );
};

export default Header;